import { register } from 'register-service-worker'

register('./OneSignalSDKWorker.js', {
    registered() {
        console.log('service worker registered')
    }
});